import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { BasicTooltip, palette } from '@livable/saas-react-components';
import { Button, TextField, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useCorrectionsDetailsStyles from './styles';
const BillTable = _ref => {
  let correctionAllocations = _ref.correctionAllocations;
  const classes = useCorrectionsDetailsStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(10),
    _useState2 = _slicedToArray(_useState, 2),
    pageSize = _useState2[0],
    setPageSize = _useState2[1];
  const notSet = t('allocations.not_set');
  const renderCell = _ref2 => {
    let dollarSign = _ref2.dollarSign,
      parameter = _ref2.parameter;
    return /*#__PURE__*/React.createElement("span", {
      className: classes.cellContent
    }, dollarSign && parameter !== null ? '$' : '', parameter == null ? notSet : parameter);
  };
  const getSingle = (className, dollarSign, parameter) => /*#__PURE__*/React.createElement("span", {
    className: classes[className]
  }, dollarSign ? '$' : '', dollarSign ? parameter.toFixed(2) : parameter);
  const renderDoubledCell = _ref3 => {
    let corrected = _ref3.corrected,
      dollarSign = _ref3.dollarSign,
      original = _ref3.original;
    return /*#__PURE__*/React.createElement("div", null, getSingle('corrected', dollarSign, corrected), /*#__PURE__*/React.createElement("br", null), getSingle('original', dollarSign, original));
  };
  const renderHeader = text => /*#__PURE__*/React.createElement("span", null, text);
  const renderCellTooltip = parameter => /*#__PURE__*/React.createElement("div", {
    className: classes.overflowCellWrapper
  }, /*#__PURE__*/React.createElement(BasicTooltip, {
    hideOnMobile: true,
    placement: "top",
    title: parameter
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.cellContent
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.overflowCell,
    variant: "body1"
  }, parameter))));
  const columns = [{
    align: 'left',
    colSpan: params => {
      var _params$row;
      if (((_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.residencyId) === 'absorption') return 9;else return undefined;
    },
    flex: 1,
    field: 'unitName',
    headerAlign: 'left',
    headerName: t('corrections.unit_name'),
    minWidth: 70,
    renderCell: params => {
      var _params$row2;
      if (((_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.residencyId) === 'absorption') return /*#__PURE__*/React.createElement("b", null, params.row.label);else return renderCellTooltip(params.row.unitName);
    },
    renderHeader: () => renderHeader(t('corrections.unit_name')),
    sortComparator: (v1, v2) => {
      var _ref4;
      return (_ref4 = '' + v1) === null || _ref4 === void 0 ? void 0 : _ref4.localeCompare(v2, undefined, {
        numeric: true
      });
    }
  }, {
    align: 'left',
    flex: 1,
    field: 'fullname',
    headerName: t('corrections.resident_name'),
    minWidth: 130,
    renderCell: params => {
      var _params$row3;
      if (((_params$row3 = params.row) === null || _params$row3 === void 0 ? void 0 : _params$row3.residencyId) === 'absorption') return;else return renderCellTooltip(params.row.fullname);
    },
    renderHeader: () => renderHeader(t('corrections.resident_name'))
  }, {
    align: 'right',
    flex: 1,
    field: 'occupantsCount',
    headerAlign: 'right',
    headerName: t('corrections.number_of_occupants'),
    minWidth: 130,
    renderCell: params => {
      var _params$row4;
      if (((_params$row4 = params.row) === null || _params$row4 === void 0 ? void 0 : _params$row4.residencyId) === 'absorption') return;else return renderCell({
        parameter: params.row.occupantsCount
      });
    },
    renderHeader: () => renderHeader(t('corrections.number_of_occupants'))
  }, {
    align: 'right',
    flex: 1,
    field: 'occupancyFactor',
    headerAlign: 'right',
    headerName: t('corrections.unit_occupancy_factor'),
    minWidth: 130,
    renderCell: params => {
      var _params$row5;
      if (((_params$row5 = params.row) === null || _params$row5 === void 0 ? void 0 : _params$row5.residencyId) === 'absorption') return;else return renderCell({
        parameter: params.row.occupancyFactor
      });
    },
    renderHeader: () => renderHeader(t('corrections.unit_occupancy_factor'))
  }, {
    align: 'right',
    flex: 1,
    field: 'numberOfDays',
    headerAlign: 'right',
    headerName: t('corrections.number_of_days'),
    minWidth: 130,
    renderCell: params => {
      var _params$row6;
      if (((_params$row6 = params.row) === null || _params$row6 === void 0 ? void 0 : _params$row6.residencyId) === 'absorption') return;else return renderDoubledCell({
        corrected: params.row.correctedNumberOfDays,
        original: params.row.originalNumberOfDays
      });
    },
    renderHeader: () => renderHeader(t('corrections.number_of_days'))
  }, {
    align: 'right',
    flex: 1,
    field: 'totalDeductions',
    headerAlign: 'right',
    headerName: 'GWD & CAD',
    minWidth: 130,
    renderCell: params => {
      var _params$row7;
      if (((_params$row7 = params.row) === null || _params$row7 === void 0 ? void 0 : _params$row7.residencyId) === 'absorption') return;else return renderDoubledCell({
        corrected: params.row.correctedTotalDeductionsAmount,
        dollarSign: true,
        original: params.row.originalTotalDeductionsAmount
      });
    },
    renderHeader: () => renderHeader('GWD & CAD')
  }, {
    align: 'right',
    flex: 1,
    field: 'utilityCap',
    headerAlign: 'right',
    headerName: t('corrections.utility_cap'),
    minWidth: 130,
    renderCell: params => {
      var _params$row8;
      if (((_params$row8 = params.row) === null || _params$row8 === void 0 ? void 0 : _params$row8.residencyId) === 'absorption') return;else return renderCell({
        dollarSign: true,
        parameter: params.row.utilityCap
      });
    },
    renderHeader: () => renderHeader(t('corrections.utility_cap'))
  }, {
    align: 'right',
    flex: 1,
    field: 'utilityCharge',
    headerAlign: 'right',
    headerName: t('corrections.utility_charge'),
    minWidth: 130,
    renderCell: params => {
      var _params$row9;
      if (((_params$row9 = params.row) === null || _params$row9 === void 0 ? void 0 : _params$row9.residencyId) === 'absorption') return;else return renderDoubledCell({
        corrected: params.row.correctedUtilityCharge,
        dollarSign: true,
        original: params.row.originalUtilityCharge
      });
    },
    renderHeader: () => renderHeader(t('corrections.utility_charge'))
  }, {
    align: 'right',
    flex: 1,
    field: 'cycleChargesTotal',
    headerAlign: 'right',
    headerName: t('corrections.cycle_charge_total'),
    minWidth: 150,
    renderCell: params => {
      var _params$row0;
      if (((_params$row0 = params.row) === null || _params$row0 === void 0 ? void 0 : _params$row0.residencyId) === 'absorption') return;else return renderDoubledCell({
        corrected: params.row.correctedTotalUtilitiesCharge,
        dollarSign: true,
        original: params.row.originalTotalUtilitiesCharge
      });
    },
    renderHeader: () => renderHeader(t('corrections.cycle_charge_total'))
  }, {
    align: 'right',
    flex: 1,
    field: 'approvedCorrection',
    headerAlign: 'right',
    headerClassName: 'adjustment-header',
    headerName: t('corrections.adjustment_charged_credited'),
    minWidth: 150,
    renderCell: params => {
      var _params$row1, _params$row10, _params$row$correctio;
      if (((_params$row1 = params.row) === null || _params$row1 === void 0 ? void 0 : _params$row1.residencyId) === 'absorption') return /*#__PURE__*/React.createElement("b", null, '$' + params.row.absorption.toFixed(2));else return /*#__PURE__*/React.createElement("b", null, renderCell({
        dollarSign: true,
        parameter: ((_params$row10 = params.row) === null || _params$row10 === void 0 ? void 0 : _params$row10.residencyId) === 'absorption' ? params.row.value : (_params$row$correctio = params.row.correctionDraft) === null || _params$row$correctio === void 0 ? void 0 : _params$row$correctio.approvedCorrection
      }));
    },
    renderHeader: () => renderHeader(t('corrections.adjustment_charged_credited'))
  }];
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      '& .adjustment-header': {
        backgroundColor: palette.shades[200],
        borderBottom: "1px solid ".concat(palette.shades[300])
      },
      [".".concat(gridClasses.cell, ".approved-correction")]: {
        backgroundColor: palette.shades[200]
      }
    }
  }, /*#__PURE__*/React.createElement(DataGrid, {
    autoHeight: true,
    columnHeaderHeight: 95,
    columns: columns,
    disableRowSelectionOnClick: true,
    getCellClassName: params => {
      if (params.field === 'approvedCorrection') return 'approved-correction';
    },
    getRowClassName: () => classes.row,
    getRowId: row => row.residencyId,
    hideFooterSelectedRowCount: true,
    initialState: {
      sorting: {
        sortModel: [{
          field: 'unitName',
          sort: 'asc'
        }]
      }
    },
    onPageSizeChange: newPageSize => setPageSize(newPageSize),
    pageSize: pageSize,
    pagination: true,
    rowHeight: 77,
    rows: correctionAllocations,
    rowsPerPageOptions: [5, 10, 20],
    slotProps: {
      filterPanel: {
        filterFormProps: {
          columnInputProps: {
            variant: 'outlined'
          },
          operatorInputProps: {
            variant: 'outlined'
          }
        }
      }
    },
    slots: {
      BaseButton: props => /*#__PURE__*/React.createElement(Button, _extends({}, props, {
        variant: "actionButton",
        'custom-attribute': '511-allocation-utility'
      })),
      BaseTextField: props => /*#__PURE__*/React.createElement(TextField, _extends({}, props, {
        variant: "outlined"
      })),
      ColumnMenuIcon: () => /*#__PURE__*/React.createElement("span", null)
    }
  }));
};
export default BillTable;